<template>
  <div class="d-logo-box df jcc aic">
    <img
      alt="home"
      class="d-logo"
      :style="{ height: height }"
      :src="src"
      @click="onClick"
    />
  </div>
</template>
 <script>
import logo from '@/assets/images/logo.png'
export default {
  name: 'Logo',
  props: {
    href: {
      default: '/',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    src: function () {
      return logo
    },
  },
  methods: {
    onClick: function (e) {
      location.assign(this.href)
    },
  },
}
</script>